<app-card [loading]="(loading$ | async) ?? false">
  <!--  todo include in another release-->
  <!--  <mat-tab-group>-->
  <!--    <mat-tab [label]="'devices.devices' | translate">-->
  <app-tab-device-list/>
  <!--    </mat-tab>-->
  <!--    <mat-tab [label]="'devices.areas.areas' | translate">-->
  <!--      not implemented yet-->
  <!--      <app-tab-area-list/>-->
  <!--    </mat-tab>-->
  <!--  </mat-tab-group>-->
</app-card>
